import { action, observable, runInAction } from "mobx";
import { api, api_adm } from "../../api";
import { toast } from "react-toastify";

export class _MvaStoreRS {
  obs = observable({
    mvas: [] as any[],
    currentPage: 1 as number,
    length_mvas: 0 as number,
    filter_vigencia: true as boolean,
    selectedTab: "entrada" as string
  })

  @action
  async handlePageFilter(page: number, filter: string) {
    let data = {
      page: page,
      limit: 20,
      filter: filter.replace(/\./g, ""),
      vigencia: this.obs.filter_vigencia,
      entrada: this.obs.selectedTab == "entrada" ? true : false
    }

    let resp = await api.post("/api/mva/rs/index", data);

    this.obs.mvas = [];
    this.obs.length_mvas = 0;

    if (resp.data.itens.length > 0) {
      this.obs.mvas = resp.data.itens
      this.obs.length_mvas = resp.data.count
    }

  }

  /**
  * Cria um novo registro de MVA no contexto do RS via admin.
  *
  * A função:
  * - Envia os dados do objeto `mva` para o endpoint `/api/admin/mva/rs/create` via **POST**.
  * - Se a resposta da API contiver `{ ok: true }`:
  *   - Exibe um `toast.success` confirmando a criação.
  * - Caso contrário:
  *   - Exibe um `toast.error` com a mensagem vinda da API (`resp.data.msg`).
  * - Em caso de exceção (falha de rede, erro inesperado), captura o erro e mostra `toast.error`.
  *
  * ## Efeitos colaterais
  * - Realiza chamada HTTP para a API administrativa (`api_adm.post`).
  * - Exibe notificações de sucesso ou erro via **toast**.
  *
  * @async
  * @param {Object} mva Objeto MVA a ser criado.
  *
  * @returns {Promise<void>} Promise após tentativa de criação.
  */

  async doSaveCreateMva(mva) {
    try {
      let resp = await api_adm.post("/api/admin/mva/rs/create", mva);
      if (resp.data.ok) {
        toast.success('MVA Criado!', {});

      } else {
        toast.error(`Não foi possível criar MVA: ${resp.data.msg}`, {});
      }

    } catch (ex) {
      toast.error(`Não foi possível criar MVA: ${ex}`, {});
    }
  }

  /**
  * Exclui um registro de MVA no contexto do RS via admin.
  *
  * A função:
  * - Faz uma requisição **DELETE** para o endpoint `/api/admin/mva/rs/:id`.
  * - Se a resposta da API contiver `{ ok: true }`:
  *   - Exibe um `toast.success` confirmando a exclusão.
  *   - Retorna `true`.
  * - Caso contrário:
  *   - Exibe um `toast.error` com a mensagem vinda da API (`resp.data.msg`).
  *   - Retorna `false`.
  * - Em caso de exceção (falha de rede, erro inesperado), captura o erro e mostra `toast.error`.
  *
  * ## Efeitos colaterais
  * - Realiza chamada HTTP para a API administrativa (`api_adm.delete`).
  * - Exibe notificações de sucesso ou erro via **toast**.
  *
  * @async
  * @param {string} id Identificador único do registro MVA a ser excluído (ObjectId do MongoDB em string).
  *
  * @returns {Promise<boolean>} `true` se o MVA foi excluído com sucesso, `false` caso contrário.
  */

  async handleDeleteMva(id) {
    try {
      let resp = await api_adm.delete(`/api/admin/mva/rs/${id}`);

      if (resp.data.ok) {
        toast.success('MVA excluído!', {});
        return true

      } else {
        toast.error(`Não foi possível exluir MVA: ${resp.data.msg}`, {});
      }

    } catch (ex) {
      toast.error(`Não foi possível excluir MVA ${ex}`, {});
    }

    return false

  }

  /**
  * Salva a edição de uma MVA no contexto do RS via admin.
  *
  * A função:
  * - Envia os dados do objeto `mva` para o endpoint `/api/admin/mva/rs/update` via **POST**.
  * - Se a resposta da API contiver `{ ok: true }`:
  *   - Exibe um `toast.success` confirmando a edição.
  *   - Retorna `true`.
  * - Caso contrário:
  *   - Exibe um `toast.error` com a mensagem vinda da API (`resp.data.msg`).
  *   - Retorna `false`.
  * - Em caso de exceção (falha de rede, erro inesperado), captura o erro e mostra `toast.error`.
  *
  * ## Efeitos colaterais
  * - Realiza chamada HTTP para a API administrativa (`api_adm.post`).
  * - Exibe notificações de sucesso ou erro via **toast**.
  *
  * @async
  * @param {Object} mva Objeto MVA a ser salvo.
  *
  * @returns {Promise<boolean>} `true` se a edição foi salva com sucesso, `false` caso contrário.
  */

  async doSaveEditMvaRs(mva) {
    try {
      let resp = await api_adm.post('/api/admin/mva/rs/update', mva);

      if (resp.data.ok) {
        toast.success('MVA Editado!', {});

      return true

      } else {
        toast.error(`Não foi possível salvar MVA: ${resp.data.msg}`, {});
      }

    } catch (ex) {
      toast.error(`Não foi possível salvar MVA: ${ex}`, {});
    }

    return false

  }

  async doSaveDuplicaMva(mva) {

    try {

      let resp = await api_adm.post('/api/admin/mva/rs/create', mva);

      if (resp.data.ok) {

        toast.success('MVA Duplicado', {});
        return true

      } else {

        toast.error(`Não foi possível duplicar o MVA: ${resp.data.msg}`, {});

      }

    } catch (ex) {

      toast.error(`Não foi possível duplicar o MVA: ${ex}`, {});

    }

    return false

  }

  async handleAplicaFrete(mva_id, checked) {

    let data = {
      id: mva_id,
      aplica_frete: checked
    }

    let resp = await api_adm.post('/api/admin/mva/rs/frete', data);

    if (resp.data.ok) {
      toast.success('Frete Atualizado!', {});
      return true

    } else {
      toast.error(`Não foi possível atualizar Frete: ${resp.data.msg}`, {});
    }

    return false

  }
}

export const MvaStoreRS = new _MvaStoreRS();
